// removed by extract-text-webpack-plugin
module.exports = {"ContactData":"ContactData__ContactData__-hash--base64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Checkout/ContactData/ContactData.css
// module id = 105
// module chunks = 0